<div class="flex justify-center mx-auto p-4 w-full md:w-[80vw]">
  <img class="aspect-[2.3] max-h-[200px]" src="assets/images/footer-pal.png" alt="Philippine Airlines Mabuhay Miles">
</div>
